// Dev-only, warn-once-per-name deprecation notice for the legacy typed button
// presets (BaseButtonPrimary/Secondary/Danger/Confirmed, BaseResetButton,
// CloseButton). They now render <BaseButton> and stay only so existing call
// sites keep working through the Wave-1/Wave-2 buttons codemod.
const warned = new Set();

export function warnDeprecatedButton(name, replacement) {
    if (import.meta.env.DEV && !warned.has(name)) {
        warned.add(name);
        console.warn(
            `[deprecated] <${name}> is deprecated — use ${replacement}. ` +
                `The typed button presets are thin wrappers over <BaseButton> and will be removed after the buttons codemod.`,
        );
    }
}
